import styled from '@emotion/styled';

export const TabsContainer = styled.div`
  height: fit-content;
  padding: 10px;
  border: 2px solid #E6E5EA;
  display: flex;
  border-radius: 10px;
  gap: 12px;
  width: 100%;
`;

export const TabsArea = styled.div`
  background-color: ${({ theme }) => theme.palette?.common?.white};
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-left: 1px solid ${({ theme }) => theme.palette?.brand?.gray[200]};
  border-right: 1px solid ${({ theme }) => theme.palette?.brand?.gray[200]};
  border-top: 1px solid ${({ theme }) => theme.palette?.brand?.gray[200]};
`;
